import { NODE_SERVER_URL, SERVER_URL } from "@/constants";
import axios from "axios";
import Swal from "sweetalert2";

const API_URL = `${NODE_SERVER_URL}/business`;

export const getBusinesss = async (filters) => {
  const params = new URLSearchParams(filters).toString();
  console.log({ filters, params });
  const response = await axios.get(`${API_URL}?${params}`);
  return { data: response.data.data, totalCount: response.data.totalCount };
};

export const deleteBusiness = async (business_id) => {
  try {
    const response = await axios.delete(`${API_URL}/${business_id}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const addBusiness = async (businessData) => {
  try {
    const response = await axios.post(
      `${API_URL}/create-multiple`,
      businessData
    );
    return response; // Return the response if successful
  } catch (error) {
    // Check if the error response exists and handle it
    if (error.response) {
      // The request was made, but the server responded with an error status code
      const errorMessage = error.response.data.message || "An error occurred";
      Swal.fire({
        icon: "error",
        text: errorMessage,
      });
    } else if (error.request) {
      // The request was made, but no response was received
      Swal.fire({
        icon: "error",
        text: "No response received from the server.",
      });
    } else {
      // Something else caused the error
      Swal.fire({
        icon: "error",
        text: error.message || "An unexpected error occurred",
      });
    }
  }
};

export const generateQr = async (qrId) => {
  try {
    const response = await axios.post(`${SERVER_URL}/api/business/qr/${qrId}`);
    return response; // Return the response if successful
  } catch (error) {
    // Check if the error response exists and handle it
    if (error.response) {
      // The request was made, but the server responded with an error status code
      const errorMessage = error.response.data.message || "An error occurred";
      Swal.fire({
        icon: "error",
        text: errorMessage,
      });
    } else if (error.request) {
      // The request was made, but no response was received
      Swal.fire({
        icon: "error",
        text: "No response received from the server.",
      });
    } else {
      // Something else caused the error
      Swal.fire({
        icon: "error",
        text: error.message || "An unexpected error occurred",
      });
    }
  }
};

export const editBusiness = async (businessId, businessData) => {
  try {
    const response = await axios.put(`${API_URL}/${businessId}`, businessData);
    return response; // Return the response if successful
  } catch (error) {
    if (error.response) {
      const errorMessage = error.response.data.message || "An error occurred";
      Swal.fire({
        icon: "error",
        text: errorMessage,
      });
    } else if (error.request) {
      Swal.fire({
        icon: "error",
        text: "No response received from the server.",
      });
    } else {
      Swal.fire({
        icon: "error",
        text: error.message || "An unexpected error occurred",
      });
    }
  }
};

export const upgradePackage = async (businessData) => {
  try {
    const response = await axios.post(
      `${API_URL}/upgrade-package`,
      businessData
    );
    return response; // Return the response if successful
  } catch (error) {
    if (error.response) {
      const errorMessage = error.response.data.message || "An error occurred";
      Swal.fire({
        icon: "error",
        text: errorMessage,
      });
    } else if (error.request) {
      Swal.fire({
        icon: "error",
        text: "No response received from the server.",
      });
    } else {
      Swal.fire({
        icon: "error",
        text: error.message || "An unexpected error occurred",
      });
    }
  }
};

export const uploadBusinessImages = async ({
  business_id,
  menu_images = [],
  photo_images = [],
  logo_image,
}) => {
  try {
    const formData = new FormData();
    formData.append("business_id", business_id);
    logo_image && formData.append("logo_image", logo_image);

    // Append menu_images (array of files)
    menu_images &&
      menu_images?.length > 0 &&
      menu_images.forEach((file) => {
        formData.append("menu_images[]", file);
      });

    // Append photo_images (array of files)
    photo_images &&
      photo_images?.length > 0 &&
      photo_images.forEach((file) => {
        formData.append("photo_images[]", file);
      });

    const response = await axios.post(
      "https://api.fly-inn.com/api/upload-business-files",
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,

          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response; // Return the response if successful
  } catch (error) {
    if (error.response) {
      const errorMessage = error.response.data.message || "An error occurred";
      Swal.fire({
        icon: "error",
        text: errorMessage,
      });
    } else if (error.request) {
      Swal.fire({
        icon: "error",
        text: "No response received from the server.",
      });
    } else {
      Swal.fire({
        icon: "error",
        text: error.message || "An unexpected error occurred",
      });
    }
  }
};

export const getRestaurantDetailById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching restaurant detail:", error);
    return null;
  }
};

export const fetchStripeProducts = async () => {
  try {
    const response = await axios.get(`${API_URL}/stripe/products`);
    return response.data.products; // adjust if the response shape is different
  } catch (error) {
    console.error("Error fetching payment plans:", error);
    return [];
  }
};

// export const payForListing = async (paymentMethodId) => {
//     return await axios.post('http://localhost:5001/payment', { paymentMethodId });
// };
